import moment from 'moment'

import { DeserializedSavedFilter } from 'api/AccountActivityAPI/types'
import {
  FilterConfigAndAvailableValues,
  FilterOperator,
  FilterPlurality,
  FilterValues,
  FilterValueType,
  getFilterConfig,
  operatorToString
} from 'utils/filters'
import { valuesToDateString, valueToDateString } from 'utils/formatDates'

const getFilterContent = (config: FilterConfigAndAvailableValues, firstFilter: FilterValues) => {
  if (config.plurality === FilterPlurality.MULTIPLE) {
    return firstFilter.values
      .slice(0, 2)
      .map((item: any) => item.label)
      .join(' or ')
  } else if (config.valueType === FilterValueType.DATE) {
    if (
      firstFilter.operator === FilterOperator.BETWEEN &&
      firstFilter.values.startDate &&
      firstFilter.values.endDate
    ) {
      return valuesToDateString(firstFilter.values)
    } else {
      return valueToDateString(moment(firstFilter.values))
    }
  } else if (config.valueType === FilterValueType.NUMBER) {
    return firstFilter.values
  } else {
    return firstFilter.values.label
  }
}

const getExtraFiltersCount = (
  config: FilterConfigAndAvailableValues,
  firstFilter: FilterValues
) => {
  const totalExtraFilters = Math.max(firstFilter.values.length - 2, 0)
  if (totalExtraFilters > 0 && config.valueType !== FilterValueType.DATE) {
    return `or ${totalExtraFilters} ${config.extraWord}`
  }

  return ''
}

export const getSavedFilterDescription = (
  allConfigs: FilterConfigAndAvailableValues[],
  filter: DeserializedSavedFilter
) => {
  const filterGroups = filter.body.filterGroups
  if (filterGroups.length === 0) {
    return ''
  }

  const firstFilter = filterGroups[0][0]
  const config = getFilterConfig(firstFilter, allConfigs)
  if (!config || (!firstFilter.values && firstFilter.values === false)) {
    return ''
  }

  return `${config?.filterDisplayName} ${operatorToString(firstFilter.operator)} ${getFilterContent(
    config,
    firstFilter
  )} ${getExtraFiltersCount(config, firstFilter)}`
}
